export const BIRouterName = {
  /** BI登录 */
  BILogin: '/bi/login',
  /** BI监管方大屏 */
  BIManageScreen: '/bi/operation_overview/manage_screen',
  /** BI运营总览 */
  BIOperationOverview: '/bi/operation_overview',
  /** BI价格跟踪 */
  BIPriceTrack: '/bi/price_track',
  /** BI供方黄页 */
  BISupplierYellowPages: '/bi/supplier_yellow_pages',
  /** BI供方黄页详情 */
  BISupplierYellowPagesDetail: '/bi/supplier_yellow_pages/detail',
  /** BI频道 */
  BIWebhookChannelList: '/bi/webhook_channel',
};
